import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  useMediaQuery,
  AppBar,
  Toolbar,
  IconButton,
  Icon,
  Typography,
  Container,
  Box,
  Slide,
  Input,
  InputAdornment,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/styles";
import { useState } from "react";
import { useContext } from "react";
import { MasterContext } from "../../context/master";
import { useEffect } from "react";
import {
  PasswordGenerator,
  ValidateHostname,
  Validation,
  CloudMailPassword,
} from "../../utils/Utils";
import SexyLoader from "../../components/interaction/sexyLoader";
import { useTranslation } from "react-i18next";
import isValidDomain  from "is-valid-domain";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: { ...theme.mixins.toolbar, marginTop: theme.spacing(2) },
  siteAddBox: {
    borderStyle: "dotted",
    width: "100%",
    borderColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
  },
  errorText: {
    border: "none",
    outline: 0,
    padding: "4px 9px 3px 8px",
    fontSize: "0.8725rem",
    transition:
      "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",

    borderRadius: "16px",

    backgroundColor: theme.palette.error.main,
    color: "#FFFFFF",
    "&:hover, &$focusVisible": { backgroundColor: theme.palette.error.main },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide unmountOnExit direction="up" ref={ref} {...props} />;
});

const SiteAddDialog = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const context = useContext(MasterContext);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [dialogOpen, setDialogOpen] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [domains, setDomains] = useState([]);
  const [Loading, SetLoading] = useState(false);
  const [domainSwapper, setDomainSwapper] = useState(false);

  const [selectedAccount, setSelectedAccount] = useState(props.AccountID);
  const [selectedDomain, setSelectedDomain] = useState();

  const [hostname, setHostname] = useState("");
  const [hostnameHelper, SetHostnameHelper] = useState("");
  const [hostnameError, SetHostnameError] = useState(false);

  const [username, setUsername] = useState("");
  const [usernameHelper, setUsernameHelper] = useState(t("UsernameHelperText"));
  const [usernameError, SetUsernameError] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordType, setPasswordType] = useState("password");

  const [acceptablePass, setAcceptablePass] = useState(false);
  const [zoneNameErrorDisplayer, setzoneNameErrorDisplayer] = useState(false);

  var cloudMailPassword = new CloudMailPassword();

  var strongRegex = new RegExp(
    "^(?=.{2,}[a-z])(?=.{2,}[A-Z])(?=.*[0-9])(?=.{2,}[!@#$:.%^&*])(?=.{14,})"
  );

  var usernameRegex = new RegExp("^[a-zA-Z][0-9a-zA-Z_.\-@]*");

  useEffect(() => {
    context.GetAccounts().then((response) => setAccounts(response));
    setUsername("admin");
  }, [context]);

  useEffect(() => {
    if (dialogOpen === true) {
      context.GetDomains().then((response) => {
        setDomains(response);
      });

      setPassword(PasswordGenerator(14));
    } else {
      setUsername("");
      setUsernameHelper("");
      setzoneNameErrorDisplayer(false);
      setHostname("");
      SetHostnameHelper("");
      SetHostnameHelper(false);
      setSelectedDomain();
    }
  }, [dialogOpen, context]);

  useEffect(() => {
    var availableDomains = Object.keys(domains)?.map((domain, domainIndex) => (
      Object.values(domains)[domainIndex]
    ))
    
      if(availableDomains.includes(true))
      {
        setDomainSwapper(false)
      }
      else{
        
        setDomainSwapper(true)
      }

  }, [domains])

  useEffect(() => {
    if (hostname !== "") {
      if (isValidDomain(hostname) && !hostname.includes(".tld")) {
        SetHostnameHelper("");
        SetHostnameError(false);
      } else {
        SetHostnameHelper(t("Please enter a valid Domain."));
        SetHostnameError(true);
      }
    } else {
      SetHostnameHelper("");
      SetHostnameError(false);
    }
  }, [hostname]);

  useEffect(() => {
    if (cloudMailPassword.ValidatePassword(password).Status) {
      setAcceptablePass(true);
    } else {
      setAcceptablePass(false);
      setPasswordError(t(cloudMailPassword.ValidatePassword(password).Message));
    }
  }, [password]);

  useEffect(() => {
    if(usernameRegex.test(username))
    {
      SetUsernameError(false);
    }
    else
    {
      SetUsernameError(true);
      setUsernameHelper(t("UsernameHelperText"))
    }
  }, [username])

  const handleCreate = () => {
    if (hostname) {
      if (selectedAccount && username && password) {
        SetLoading(true);
        context
          .CreateSite(selectedAccount, hostname, username, password)
          .then((response) => {
            if (response.statusText === "Bad Request") {
              setzoneNameErrorDisplayer(true);

              SetLoading(false);
            } else {
              setzoneNameErrorDisplayer(false);
              SetLoading(false);
              setDialogOpen(false);
            }
          })
          .catch((error) => {
            SetLoading(false);
            setDialogOpen(false);
          });
      }
    } else if (selectedDomain) {
      if (selectedAccount && username && password) {
        SetLoading(true);
        context
          .CreateSite(selectedAccount, selectedDomain, username, password)
          .then((response) => {
            SetLoading(false);
            setDialogOpen(false);
            setzoneNameErrorDisplayer(false);
          })
          .catch((error) => {
            SetLoading(false);
            setDialogOpen(false);
          });
      }
    }
  };

  useEffect(() => {
    if (username) setUsername(username.replace(/\s+/g, ""));
    setPassword(password.replace(/\s+/g, ""));
  }, [username, password]);

  return (
    <>
      <Container maxWidth={false}>
        <Grid container justify="center">
          <Box textAlign="center" className={classes.siteAddBox} p={3}>
            <Button
              size="large"
              color="primary"
              startIcon={<Icon fontSize={"large"}>add</Icon>}
              variant="outlined"
              onClick={() => setDialogOpen(true)}
            >
              {t("CREATE WEBSITE")}
            </Button>
          </Box>
        </Grid>
      </Container>
      <Dialog
        TransitionComponent={Transition}
        fullScreen={fullScreen}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      >
        {!fullScreen ? (
          <DialogTitle>{t("Create Site")}</DialogTitle>
        ) : (
          <AppBar color="default">
            <Toolbar>
              <IconButton
                onClick={() => setDialogOpen(false)}
                edge="start"
                className={classes.menuButton}
              >
                <Icon>close</Icon>
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                {t("Create Site")}
              </Typography>
              <Button onClick={handleCreate} color="inherit">
                {t("CREATE")}
              </Button>
            </Toolbar>
          </AppBar>
        )}
        {fullScreen && <div className={classes.appBar}></div>}

        <DialogContent className={classes.content}>
          <DialogContentText>{t("CREATE WEBSITE DESC")}</DialogContentText>
          {zoneNameErrorDisplayer === true && (
            <DialogContentText className={classes.errorText}>
              {t("ExistingDomainError")}
            </DialogContentText>
          )}
          <Grid container spacing={2}>
            <SexyLoader IsLoading={Loading}>
              <Grid item xs={12}>
                <FormControl className={classes.formControl}>
                  <InputLabel>{t("Account")}</InputLabel>
                  <Select
                    onChange={(event) => setSelectedAccount(event.target.value)}
                    value={selectedAccount}
                    disabled={props.AccountID}
                  >
                    {accounts
                      .filter(
                        (account) =>
                          account.Sites.length < account.Account.LimitWebSpaces
                      )
                      .map((account, accountIndex) => (
                        <MenuItem
                          value={account.Account.Account_ID}
                          key={account.Account.Account_ID}
                        >
                          {`${account.Account.Account_Name} - ${t(
                            account.Account.PackageName
                          )} - ${account.Sites.length}/${
                            account.Account.LimitWebSpaces
                          }`}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                {domainSwapper === false ? (
                  <FormControl className={classes.formControl}>
                    <InputLabel>{t("Domains")}</InputLabel>
                    <Select
                      onChange={(event) => {
                        setSelectedDomain(event.target.value);
                      }}
                      value={selectedDomain}
                    >
                      {Object.keys(domains)?.map((domain, domainIndex) => (
                        <MenuItem
                          value={domain}
                          key={domain}
                          disabled={!Object.values(domains)[domainIndex]}
                        >
                          {`${domain}` +
                            "   " +
                            `${
                              Object.values(domains)[domainIndex] === true
                                ? t("Available")
                                : t("Not Available")
                            }`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    value={hostname}
                    onChange={(event) => setHostname(event.target.value)}
                    error={hostnameError}
                    helperText={hostnameHelper}
                    fullWidth
                    label={t("Domain")}
                  ></TextField>
                )}
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  size={"large"}
                  startIcon={<Icon style={{ fontWeight: 900 }}>add</Icon>}
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    if (domainSwapper && selectedDomain) {
                      setSelectedDomain();
                    } else if (!domainSwapper && hostname) {
                      setHostname("");
                    }

                    setDomainSwapper(!domainSwapper);
                  }}
                >
                  {domainSwapper === false
                    ? t("ADD ANOTHER DOMAIN")
                    : t("ADD EXISTING DOMAIN")}
                </Button>
              </Grid>
              <Grid item xs={6}>

                <TextField
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                  error={usernameError}
                  helperText={usernameError && usernameHelper}
                  fullWidth
                  label={t("Username")}
                ></TextField>


                  

              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="standard-adornment-password">
                    {t("Password")}
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    value={password}
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                    error={acceptablePass === false ? true : false}
                    type={passwordType}
                    fullWidth
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            setPasswordType(
                              passwordType === "password" ? "text" : "password"
                            )
                          }
                        >
                          <Icon>
                            {passwordType === "password"
                              ? "visibility"
                              : "visibility_off"}
                          </Icon>
                        </IconButton>
                      </InputAdornment>
                    }
                  ></Input>
                  {acceptablePass === false && (
                    <FormHelperText id="standard-weight-helper-text">
                      {passwordError}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </SexyLoader>
          </Grid>
        </DialogContent>
        {!fullScreen && (
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)} color="default">
              {t("CANCEL")}
            </Button>

            <Button
              disabled={
                acceptablePass === true
                  ? domainSwapper === false
                    ? !selectedDomain || !selectedAccount || !username
                    : !ValidateHostname(hostname) ||
                      !selectedAccount ||
                      !username
                  : true
              }
              onClick={handleCreate}
              color="primary"
            >
              {t("CREATE")}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default SiteAddDialog;
